import React, { useState } from "react";
import { Card, Typography, Button, Space } from 'antd';
import { Link as RouterLink } from "react-router-dom";
import string from "../../constants/constants";
import { componentStyles } from "./LimitTrialPageStyles";
import { CloseOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import SubscriptionRestrictionModal from "../../components/subscriptionIOSRestrictionModal/SubscriptionIOSRestrictionModal";

import "./LimitTrialPageStyles.css";

const LimitTrialCard = ({ onClose }) => {

  const { Text } = Typography;
  const navigate = useNavigate();
  const [iosModalVisible, setIosModalVisible] = useState(false);
  const isIosUser = localStorage.getItem("userPlatform") === "ios";

  const handleConversationButtonClick = () => {
    // iOS users cannot manage subscriptions on the web (Apple policy). Routing them
    // to /subs2 dead-ends at the iOS restriction modal, so show the explanation here
    // instead of navigating into a blocked route.
    if (isIosUser) {
      setIosModalVisible(true);
    } else {
      navigate("/subs2");
    }
  };

  return (
    <Card className="limit-trial-card" style={componentStyles.cardStyle} >
              <CloseOutlined className="close-icon" onClick={onClose} />

      <h1 style={componentStyles.titleStyle}>
        {string.limitPageHeader}
      </h1>
      <Text className="text-para-style">
        To access unlimited conversation time with Amy/Arthur, upgrade your
        subscription now. If you are not quite sure you’re ready to commit to a
        subscription yet, We offer only one week free trial from the date of signup.
      </Text>
      <br />
      <Space className="buttons">
        <Button onClick={handleConversationButtonClick} style={componentStyles.button3} className="limit-width-button">
          View Subscription Options
        </Button>
        <RouterLink to="/landing-page" style={{ textDecoration: "none" }}>
          <Button style={componentStyles.button2}>
            {string.returnToHome}
          </Button>
        </RouterLink>
      </Space>
      <SubscriptionRestrictionModal
        visible={iosModalVisible}
        onCancel={() => setIosModalVisible(false)}
      />
    </Card>
  );
}
export default LimitTrialCard;
